import React from 'react'
import Tile from './Tile'

const DataMap = ({data, type}) => {
  return (
    <>
        {data.map((d, key) => (
            <div key={key} className="">
                <Tile data={d} type={type}/>
            </div>
        ))}
    </>
  )
}

export default DataMap